import {
  ADD_SIGNALS,
  CLEAN_SIGNALS,
  cleanSignalsActionType,
  createSignalPayload,
  sendSignalsActionType,
  signalsPayload,
  TOGGLE_SIGNALS,
  toggleSignalsActionType,
} from './types';

export const sendSignalsAction = (
  signalsValuesPool: createSignalPayload,
): sendSignalsActionType => {
  return {
    type: ADD_SIGNALS,
    signalsValuesPool,
  };
};

export const cleanSignalsAction = (
  signalsToDrop: signalsPayload,
): cleanSignalsActionType => {
  return {
    type: CLEAN_SIGNALS,
    signalsToDrop,
  };
};

export const toggleSignalsAction = (
  signalsToToggle: signalsPayload,
): toggleSignalsActionType => {
  return {
    type: TOGGLE_SIGNALS,
    signalsToToggle,
  };
};
